<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TransportationDepartureBlockDays',
  props: {
    shown: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      departureBlockDaysValid: false,
      headers: [
        { text: 'ID', sortable: false, class: 'px-4' },
        { text: 'Price ID', sortable: false, class: 'px-2' },
        { text: 'Available', sortable: false, class: 'px-2' },
        { text: 'Blocked', sortable: false, class: 'px-1' },
      ],
    };
  },
  computed: {
    ...mapState({
      departure: state => state.transportation.prices.season.selectedDeparture,
      blockedDays: state => state.transportation.departures.blockDays.items,
      loading: state => state.transportation.departures.blockDays.loading,
      error: state => state.transportation.departures.blockDays.error,
    }),
  },
  methods: {
    ...mapActions({
      addDepartureBlockDay: 'transportation/addDepartureBlockDay',
      deleteDepartureBlockDay: 'transportation/deleteDepartureBlockDay',
    }),
    addOrDeleteDepartureBlockDay(action, item) {
      if (action) {
        this.addDepartureBlockDay({
          seasonDepartureId: this.departure.id,
          direction: this.departure.direction,
          body: {
            ferrySeasonPriceDayId: item.id,
          },
        });
      } else {
        this.deleteDepartureBlockDay({
          seasonDepartureId: this.departure.id,
          direction: this.departure.direction,
          body: {
            ferrySeasonPriceDayId: item.id,
          },
        });
      }
    },
  },
};
</script>

<template>
  <v-card
    v-if="shown"
  >
    <v-card-title class="pb-1">
      <span class="headline">
        Blocked days for "{{ departure.name }}"
      </span>
    </v-card-title>
    <v-card-text class="py-0 mb-3">
      <v-container grid-list-md pt-1>
          <v-data-table
            :items="blockedDays"
            :headers="headers"
            :loading="loading"
            hide-actions
          >
            <template v-slot:no-data>
              <tr v-if="!error">
                <td colspan="4" class="text-xs-center">No results found</td>
              </tr>
              <tr v-else>
                <td colspan="4" class="text-xs-center">Error</td>
              </tr>
            </template>
            <template v-slot:items="data">
              <td class="px-4">
                {{ data.item.id }}
              </td>
              <td class="px-2">
                {{ data.item.ferrySeasonPriceId }}
              </td>
              <td class="px-2">
                {{ data.item.availableAt }}
              </td>
              <td class="px-1">
                <v-checkbox
                  v-model="data.item.blocked"
                  @change="addOrDeleteDepartureBlockDay($event, data.item)"/>
              </td>
            </template>
          </v-data-table>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="blue darken-1"
        flat
        @click="$emit('close')"
      >
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>



// WEBPACK FOOTER //
// src/components/transportation/TransportationDepartureBlockDays.vue